import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FnFloatAction } from './fn-float-btn.model';

@Component({
    selector: 'fn-float-btn',
    templateUrl: './fn-float-btn.component.html',
    styleUrls: ['./fn-float-btn.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FnFloatBtnComponent implements OnInit {

  cdnImageUrl = 'https://agcdn.altametrics.com/hubworks_resources/pre_dev/images/help/';

  @Input() imgUrl = '';

  @Input() imgClass = '';

  @Input() fnIcon = '';

  @Input() floatBtnClass = '';

  @Input() appVersion = '';

  @Input() floatActionList: FnFloatAction[] = [];

  @Input() btnDirection: 'left' | 'right' | 'center' = 'right';

  @Output() actionOnBtn: EventEmitter<FnFloatAction> = new EventEmitter();

  ngOnInit(): void {
    this.floatBtnClass += this.btnDirection;
  }

}
